import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import EventButton from '../EventButton';
import { ALBUM_SUBTYPE } from '../../../../../../constants/albums';
import useGtagManualTracking from '../../../../../../services/gtag/useGtagManualTracking';
import { EVENTS } from '../../../../../../services/gtag/constants';

const propTypes = {
  onEventClick: PropTypes.func.isRequired,
  shouldSkipEvent: PropTypes.func,
  className: PropTypes.string,
};

const EventSelection = ({ onEventClick, shouldSkipEvent, className }) => {
  const { onTrackEvent } = useGtagManualTracking();
  const classes = classNames({
    'event-selection-wrapper': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.WEDDINGS) && (
        <EventButton
          label="Wedding"
          icon="/wedding-event-photo-icon.png"
          onClick={() => {
            onTrackEvent({
              event: EVENTS.CLICK_EVENT_TILE,
              data: {
                page_title: 'SE wedding tile',
              },
            });
            onEventClick({ eventType: ALBUM_SUBTYPE.WEDDINGS });
          }}
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.BIRTHDAYS) && (
        <EventButton
          label="Birthday"
          icon="/birthday-event-photo-icon.png"
          onClick={() => onEventClick({ eventType: ALBUM_SUBTYPE.BIRTHDAYS })}
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.ANNIVERSARIES) && (
        <EventButton
          label="Anniversary"
          icon="/anniversary-event-photo-icon.png"
          onClick={() =>
            onEventClick({ eventType: ALBUM_SUBTYPE.ANNIVERSARIES })
          }
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.GRADUATIONS) && (
        <EventButton
          label="Graduation"
          icon="/graduation-event-photo-icon.png"
          onClick={() => onEventClick({ eventType: ALBUM_SUBTYPE.GRADUATIONS })}
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.MEMORIALS) && (
        <EventButton
          label="Memorial"
          icon="/memorial-event-photo-icon.png"
          onClick={() => onEventClick({ eventType: ALBUM_SUBTYPE.MEMORIALS })}
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.VACATIONS) && (
        <EventButton
          label="Vacation"
          icon="/vacation-event-photo-icon.png"
          onClick={() => onEventClick({ eventType: ALBUM_SUBTYPE.VACATIONS })}
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.FUNDRAISERS) && (
        <EventButton
          label="Fundraiser"
          icon="/fundraiser-event-photo-icon.png"
          onClick={() => onEventClick({ eventType: ALBUM_SUBTYPE.FUNDRAISERS })}
        />
      )}
      {!shouldSkipEvent?.(ALBUM_SUBTYPE.CUSTOM_EVENT) && (
        <EventButton
          label="Custom Event"
          icon="/custom-event-photo-icon.png"
          onClick={() =>
            onEventClick({ eventType: ALBUM_SUBTYPE.CUSTOM_EVENT })
          }
        />
      )}
    </div>
  );
};

EventSelection.propTypes = propTypes;

export default EventSelection;
